import React from 'react'

import NavLink from 'app/components/util/lgy-nav-link/LgyNavLink'

const OversightLeftNav = ({ canCreateAudit, canViewActiveAudits, location }) =>
  <nav className='oversight-left-nav'>
    <ul className='usa-sidenav-list'>
      {canViewActiveAudits && <li>
        <NavLink activeClassName={location.pathname === '/lgyhub/oversight' ? 'usa-current' : ''} to='/lgyhub/oversight'>
          Oversight Workspace
        </NavLink>
      </li>}
      <li>
        <NavLink activeClassName='usa-current' to='/lgyhub/oversight/search'>Search Audit Records</NavLink>
      </li>
      {canCreateAudit && <li>
        <NavLink activeClassName='usa-current' to='/lgyhub/oversight/create'>Create Audit Record</NavLink>
      </li>}
    </ul>
  </nav>

export default OversightLeftNav
